import React from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const AuthorizationModal = ({ open, onClose, authorization, onAuthorize, scrollClassName }) => {
    const authorizeBtnRef = React.useRef(null);
    React.useEffect(() => {
        if (open && authorizeBtnRef.current) {
            authorizeBtnRef.current.focus();
        }
    }, [open]);
    return (
        <Transition.Root show={open} as={React.Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <Transition.Child
                    as={React.Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <Transition.Child
                        as={React.Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <Dialog.Panel className="bg-white rounded-xl shadow-xl max-w-lg w-full p-6">
                            <div className="flex flex-col items-center mb-2">
                                <ExclamationTriangleIcon className="h-10 w-10 text-yellow-500 mb-2" />
                                <Dialog.Title className="text-xl font-bold mb-2 text-gray-800 text-center">{authorization?.title || 'Autorização Necessária'}</Dialog.Title>
                            </div>
                            <div className={`mb-4 text-gray-600 whitespace-pre-line text-center break-words max-w-full ${scrollClassName || ''}`} style={{ wordBreak: 'break-word', whiteSpace: 'pre-line', maxHeight: 240, overflowY: 'auto' }}>{authorization?.authorization}</div>
                            <div className="mb-4 text-xs text-gray-500 text-center">
                                Ao autorizar, seu <span className="font-bold text-gray-700">IP</span>, <span className="font-bold text-gray-700">dispositivo</span> e <span className="font-bold text-gray-700">porcentagem lida</span> serão registrados para segurança.
                            </div>
                            <div className="flex justify-end gap-2 mt-4">
                                <button className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700" onClick={onClose}>Cancelar</button>
                                <button ref={authorizeBtnRef} className="px-4 py-2 rounded bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white font-semibold shadow-lg focus:ring-2 focus:ring-blue-400 focus:outline-none transition" onClick={onAuthorize}>Autorizar</button>
                            </div>
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    );
};

export default AuthorizationModal; 